import dayjs from 'dayjs'

import {
  ECampaignKeys,
  TCampaignCreatePayload,
  TOFUCampaignFormFields,
} from '~/features/campaigns/models'
import { OUTREACH_TIME_ASAP_VALUE } from '~/features/campaigns/utils/constants'
import { getOutreachInstructionsSaveFields } from '~/features/campaigns/utils/outreachInstructions'

export const prepareApiPayload = (
  payload: Partial<TOFUCampaignFormFields>,
  timezone: string,
): TCampaignCreatePayload => {
  const transformedPayload = { ...payload } as TCampaignCreatePayload

  if ('startDate' in payload) {
    transformedPayload.startDate = payload.startDate
      ? dayjs(payload.startDate)
          .tz(timezone)
          .hour(8)
          .minute(0)
          .second(0)
          .millisecond(0)
          .toISOString()
      : undefined
  }

  if ('endDate' in payload) {
    transformedPayload.endDate = payload.endDate
      ? dayjs(payload.endDate)
          .tz(timezone)
          .hour(20)
          .minute(0)
          .second(0)
          .millisecond(0)
          .toISOString()
      : undefined
  }

  if (
    ECampaignKeys.ofuOutreachTime in payload &&
    payload.ofu_outreachTime === OUTREACH_TIME_ASAP_VALUE
  ) {
    transformedPayload.ofu_outreachTime = undefined
  } else if (
    ECampaignKeys.ofuOutreachTime in payload &&
    payload.ofu_outreachTime
  ) {
    const [hours, minutes] = payload.ofu_outreachTime.split(':')
    // Build an ISO-8601 string whose time portion exactly matches the selected
    // hour from the dropdown (no timezone conversion). Using UTC ensures
    // toISOString preserves the picked hour, e.g. "09:00" -> "...T09:00:00.000Z".
    transformedPayload.ofu_outreachTime = dayjs
      .utc()
      .hour(parseInt(hours, 10))
      .minute(parseInt(minutes, 10))
      .second(0)
      .millisecond(0)
      .toISOString()
  }

  if ('campaignFacts' in payload && payload.campaignFacts) {
    transformedPayload.campaignFacts = payload.campaignFacts.map((fact) => ({
      id: fact.id,
      text: fact.fact,
    }))
  }

  if (ECampaignKeys.outreachInstructionsText in payload) {
    Object.assign(
      transformedPayload,
      getOutreachInstructionsSaveFields(
        payload[ECampaignKeys.outreachInstructionsText],
      ),
    )
  }

  return transformedPayload
}

export default prepareApiPayload
